import { useCallback, useEffect, useRef, useState } from "react";

const LOADING_DELAY = 250;

export default function useDelayedLoading(delay = LOADING_DELAY) {
  const [loading, setLoading] = useState(false);
  const inFlightRef = useRef(0);
  const showTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showingRef = useRef(false);

  useEffect(
    () => () => {
      if (showTimeoutRef.current) clearTimeout(showTimeoutRef.current);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    },
    [],
  );

  const start = useCallback(() => {
    inFlightRef.current += 1;

    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
      hideTimeoutRef.current = null;
    }
    if (showingRef.current || showTimeoutRef.current) return;

    showTimeoutRef.current = setTimeout(() => {
      showTimeoutRef.current = null;
      showingRef.current = true;
      setLoading(true);
    }, delay);
  }, [delay]);

  const stop = useCallback(() => {
    inFlightRef.current = Math.max(0, inFlightRef.current - 1);
    if (inFlightRef.current > 0) return;

    if (showTimeoutRef.current) {
      clearTimeout(showTimeoutRef.current);
      showTimeoutRef.current = null;
    }

    hideTimeoutRef.current = setTimeout(() => {
      hideTimeoutRef.current = null;
      showingRef.current = false;
      setLoading(false);
    });
  }, []);

  return { loading, start, stop };
}
